import {
	PRODUCT,
	DATATABLE_EXPORT,
	PRODUCT_CATEGORY,
} from "../../../../Config/ApiUrl";

export const DetailUsagesDeductionsSchema = {
	data() {
		return {
			DATATABLE_EXPORT,
			// isAddEditModalActive: false,
			// deleteConfirmationModalActive: false,
			deleteLoader: false,
			// selectedUrl: this.ENDPOINT,
			// tableId: "DEDUCTIONS-table",
			rowData: {},
			// formId: "DETAIL-USAGES-DEDUCTIONS-modal",
			tableColumns: [
				{
					title: "Invoice",
					type: "custom-html",
					key: "invoice_no",
					modifier: (value) => {
						return value ? value : "";
					},
				},
			],
			ENDPOINT: PRODUCT + "/" + this.value.id + "/voucher/usage",
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "Product",
				url: PRODUCT + "/" + this.value.id + "/voucher/usage",
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: false,
				columns: [],
				actions: [
				],
				filters: [
				],
				showFilter: false,
				showSearch: true,
				showCount: true,
				showClearFilter: false,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 5,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(value);
		},
	},
};
